/**
 * Shell icons (sidebar, top bar, search, drawer): Flaticon UIcons regular rounded,
 * the same pack as ROP-teams (Bill 2026-11-04: one icon pack across every PCB app).
 * Bundled from npm via each app's main.tsx CSS import; no CDN. Decorative
 * (aria-hidden): the text next to them carries the meaning.
 */

import type { ShellIconName } from './types';
import { FiIcon } from './fi';

/** Shell icon name → Flaticon slug. */
export const SHELL_ICON_SLUGS: Record<ShellIconName, string> = {
  home: 'home',
  search: 'search',
  menu: 'menu-burger',
  close: 'cross-small',
  users: 'users',
  'user-check': 'user-check',
  settings: 'settings',
  sliders: 'settings-sliders',
  clock: 'clock',
  history: 'time-past',
  list: 'list',
  shield: 'shield',
  file: 'document',
  alert: 'triangle-warning',
  check: 'check',
  info: 'info',
  eye: 'eye',
  tool: 'tools',
  building: 'building',
  box: 'box',
  chart: 'chart-histogram',
  mail: 'envelope',
  key: 'key',
  calendar: 'calendar',
  message: 'comment',
  database: 'database',
  'chevron-right': 'angle-small-right',
  'chevron-down': 'angle-small-down',
  external: 'arrow-up-right-from-square',
};

export function ShellIcon({ name, size = 18, className }: { name: ShellIconName; size?: number; className?: string }): JSX.Element {
  return <FiIcon slug={SHELL_ICON_SLUGS[name]} size={size} className={className} />;
}
